export default __webpack_public_path__ + "static/media/fontawesome-webfont.8b43027f.eot";